require('./externalTransferValuesView.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKMessage } = require('commonsComponents/OKMessage');

// @components
const ExternalTransferValuesStep1 = require('../../components/externalTransferValuesSteps/externalTransferValuesStep1/externalTransferValuesStep1');
const ExternalTransferValuesStep2 = require('../../components/externalTransferValuesSteps/externalTransferValuesStep2/externalTransferValuesStep2');
const ExternalTransferValuesStep3 = require('../../components/externalTransferValuesSteps/externalTransferValuesStep3/externalTransferValuesStep3');
const ExternalTransferValuesSuccessScreen = require('../../components/externalTransferValuesSteps/externalTransferValuesSuccessScreen/externalTransferValuesSuccessScreen');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WizardError = require('components/commons/wizardError/wizardError');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

// @actions
const externalTransferValuesActions = require('actions/externalTransferValues');
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');

// @ constants
const {
    MYPROFILE_BROKER_URL,
    BROKER_PG_URL,
    FIRST_STEP,
    SECOND_STEP,
    TYPE_GENERAL_PRODUCT
} = require('constants/index');

class ExternalTransferValuesView extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.fetchMyInvestments();
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    buildHeader() {
        const { match: { params: { productType } } } = this.props;
        let productName = TYPE_GENERAL_PRODUCT;
        if (!!productType) {
            productName = productType;
        }
        const productLabel = formatText(`externalTransferValues-externalTransferValues_${productName}`);
        const title = formatText('breadcrumb-breadcrumb_externalTransferValues', [productLabel]);
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: title
            }
        ];

        return (
            <OKCover size="medium" section="broker" customClass="col-xs-12">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    finalTitle={title}>
                </OKHeaderSubPage>
            </OKCover>
        );
    }

    handleCancel() {
        this.props.history.push(MYPROFILE_BROKER_URL);
    }

    handleFinish() {
        this.props.confirmExternalTransfer();
    }

    buildWizard() {
        const {
            addAnotherProduct,
            addFile,
            deleteProduct,
            immExternalTransferValues,
            immStocksContracts,
            match: { params: { productType } },
            removeFile,
            resetDuplicateError,
            setBankName,
            setBrokerSearchField,
            setContractNumber,
            setDestinationAccount,
            setNoOfProducts,
            setVisibleStep,
            setWillCancel,
            undoDeletion,
            validateStep
        } = this.props;

        const actions = {
            validateStep,
            setWillCancel,
            setVisibleStep,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };

        let productName = TYPE_GENERAL_PRODUCT;
        if (!!productType) {
            productName = productType;
        }

        const immSteps = immExternalTransferValues.get('steps');
        const immFirstStep = immSteps.get(FIRST_STEP);
        const immSecondStep = immSteps.get(SECOND_STEP);
        const visibleStep = immExternalTransferValues.get('visibleStep');
        const isSubmitInProgress = immExternalTransferValues.get('isFetching');
        const productLabel = formatText(`externalTransferValues-externalTransferValues_${productName}`);
        const operativeName = formatText('breadcrumb-breadcrumb_externalTransferValues', [productLabel]);
        const selectedProductsArray = immSecondStep.get('selectedProductsArray');
        const disabledSecondStepActionButton = !selectedProductsArray.getIn([0, 'product']);

        return (
            <Wizard
                actions={actions}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                immSteps={immSteps}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButtonDisabled={immFirstStep.get('filesAttached').size === 0}
                >
                    <ExternalTransferValuesStep1
                        immStocksContracts={immStocksContracts}
                        setDestinationAccount={setDestinationAccount}
                        immStep={immFirstStep}
                        immExternalTransferValues={immExternalTransferValues}
                        setContractNumber={setContractNumber}
                        setBankName={setBankName}
                        addFile={addFile}
                        removeFile={removeFile}
                    />
                </WizardStep>
                <WizardStep
                    position="middle"
                    cancelButton={true}
                    nextButtonDisabled={disabledSecondStepActionButton}
                >
                    <ExternalTransferValuesStep2
                        addAnotherProduct={addAnotherProduct}
                        deleteProduct={deleteProduct}
                        immStep={immSecondStep}
                        productType={productType}
                        resetDuplicateError={resetDuplicateError}
                        setBrokerSearchField={setBrokerSearchField}
                        setNoOfProducts={setNoOfProducts}
                        undoDeletion={undoDeletion}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    immFinalButton="accountDirectDebitsView-submitButton"
                    addLoadingBehaviour={true}
                    isLoading={isSubmitInProgress}
                >
                    <ExternalTransferValuesStep3
                        immExternalTransferValues={immExternalTransferValues}
                        operativeName={operativeName}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildSuccessScreen() {
        const { immExternalTransferValues } = this.props;
        const mainButton = {
            label: formatText('brokerExternalTransferFundSuccess-finish'),
            url: BROKER_PG_URL,
            modifier: 'secondary'
        };

        return (
            <div className="external-transfer-values-view__result-screen">
                <WizardSuccess
                    successMessage={formatText('externalTransferValues-externalTransferValues_successTitle')}
                    mainButton={mainButton}
                >
                    <div className="external-transfer-values-view__informative-box">
                        <OKMessage type="informative" modifier="dark-bg">
                            <FormattedText value="externalTransferValues-externalTransferValues_successInformationMessage" />
                        </OKMessage>
                    </div>
                    <ExternalTransferValuesSuccessScreen
                        immExternalTransferValues={immExternalTransferValues}
                    />
                </WizardSuccess>
            </div>
        );
    }

    buildErrorScreen() {
        const { immExternalTransferValues } = this.props;
        const mainButton = {
            label: formatText('brokerExternalTransferFundSuccess-finish'),
            url: BROKER_PG_URL,
            modifier: 'secondary'
        };

        return (
            <WizardError
                errorMessage={formatText('externalTransferValues-externalTransferValues_errorTitle')}
                mainButton={mainButton}
            >
                <FormattedText
                    className="external-transfer-values-view__error-text"
                    value="externalTransferValues-externalTransferValues_errorSubtitle"
                />
                <ExternalTransferValuesSuccessScreen
                    immExternalTransferValues={immExternalTransferValues}
                />
            </WizardError>
        );
    }

    render() {
        const { immExternalTransferValues } = this.props;
        let bodyBlock;
        const submitSuccessful = immExternalTransferValues.get('submitSuccessful');
        const submitError = immExternalTransferValues.get('submitError');
        const header = this.buildHeader();

        if (submitSuccessful) {
            bodyBlock = this.buildSuccessScreen();
        } else if (submitError) {
            bodyBlock = this.buildErrorScreen();
        } else {
            bodyBlock = this.buildWizard();
        }

        return (
            <div className="external-transfer-values-view">
                <div className="container-fluid">
                    <div className="row">
                        {header}
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {bodyBlock}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ExternalTransferValuesView.propTypes = {
    addFile: PropTypes.func.isRequired,
    addAnotherProduct: PropTypes.func.isRequired,
    confirmExternalTransfer: PropTypes.func.isRequired,
    deleteProduct: PropTypes.func.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immExternalTransferValues: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    match: PropTypes.object,
    resetState: PropTypes.func.isRequired,
    resetDuplicateError: PropTypes.func.isRequired,
    removeFile: PropTypes.func.isRequired,
    setBankName: PropTypes.func.isRequired,
    setContractNumber: PropTypes.func.isRequired,
    setDestinationAccount: PropTypes.func.isRequired,
    setNoOfProducts: PropTypes.func.isRequired,
    setBrokerSearchField: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    undoDeletion: PropTypes.func.isRequired,
}

module.exports.constructor = ExternalTransferValuesView;
module.exports.ExternalTransferValuesView = connect(state => ({
    immExternalTransferValues: state.externalTransferValues,
    immStocksContracts: state.brokerStocksContract
}), {
    addAnotherProduct: externalTransferValuesActions.addAnotherProduct,
    addFile: externalTransferValuesActions.addFile,
    confirmExternalTransfer: externalTransferValuesActions.confirmExternalTransfer,
    deleteProduct: externalTransferValuesActions.deleteProduct,
    fetchMyInvestments: BrokerMyInvestmentsActions.fetchMyInvestments,
    resetState: externalTransferValuesActions.resetState,
    resetDuplicateError: externalTransferValuesActions.resetDuplicateError,
    removeFile: externalTransferValuesActions.removeFile,
    setBankName: externalTransferValuesActions.setBankName,
    setContractNumber: externalTransferValuesActions.setContractNumber,
    setDestinationAccount: externalTransferValuesActions.setDestinationAccount,
    setNoOfProducts: externalTransferValuesActions.setNoOfProducts,
    setBrokerSearchField: externalTransferValuesActions.setBrokerSearchField,
    setVisibleStep: externalTransferValuesActions.setVisibleStep,
    setWillCancel: externalTransferValuesActions.setWillCancel,
    validateStep: externalTransferValuesActions.validateStep,
    undoDeletion: externalTransferValuesActions.undoDeletion,
})(withRouter(ExternalTransferValuesView));
